import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useState } from 'react';
import { Typography, ToggleButtonGroup, ToggleButton, InputLabel, InputAdornment, FormControl, OutlinedInput } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import { useStore } from 'src/stores';
import useStyles from './styles';
import { FEE_UNIT_TYPES } from 'src/constants/feesSetting';
export const LateFee = observer(() => {
  var _store$homeDashboardS, _store$homeDashboardS2, _store$homeDashboardS4, _store$homeDashboardS5, _store$homeDashboardS6, _store$homeDashboardS7, _store$homeDashboardS13, _store$homeDashboardS14;
  const store = useStore();
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const feeName = 'lateFee';

  // Note: Just made a quick implementation for new LateFee LB-1901
  const feeCurrency = (_store$homeDashboardS = (_store$homeDashboardS2 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS2 === void 0 || (_store$homeDashboardS2 = _store$homeDashboardS2.selectedPropertyDetails().details.feeSetup.getPropertyFee({
    feeName
  })) === null || _store$homeDashboardS2 === void 0 ? void 0 : _store$homeDashboardS2.feeUnitType) !== null && _store$homeDashboardS !== void 0 ? _store$homeDashboardS : FEE_UNIT_TYPES.fixedAmount;
  const isFeeExcluded = () => {
    var _store$homeDashboardS3;
    return ((_store$homeDashboardS3 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS3 === void 0 ? void 0 : _store$homeDashboardS3.selectedPropertyDetails().details.feeSetup.getPropertyFee({
      feeName
    })) === null;
  };
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isInputTouched = _useState2[0],
    setInputTouched = _useState2[1];
  const feeUnitType = (_store$homeDashboardS4 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS4 !== void 0 && (_store$homeDashboardS4 = _store$homeDashboardS4.selectedPropertyDetails().details.feeSetup.getPropertyFee({
    feeName
  })) !== null && _store$homeDashboardS4 !== void 0 && _store$homeDashboardS4.feeUnitType ? (_store$homeDashboardS5 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS5 === void 0 || (_store$homeDashboardS5 = _store$homeDashboardS5.selectedPropertyDetails().details.feeSetup.getPropertyFee({
    feeName
  })) === null || _store$homeDashboardS5 === void 0 ? void 0 : _store$homeDashboardS5.feeUnitType : '';
  const inputValue = (_store$homeDashboardS6 = store.homeDashboardStore.getCurrentCompany) !== null && _store$homeDashboardS6 !== void 0 && (_store$homeDashboardS6 = _store$homeDashboardS6.selectedPropertyDetails().details.feeSetup.getPropertyFee({
    feeName
  })) !== null && _store$homeDashboardS6 !== void 0 && _store$homeDashboardS6.value ? (_store$homeDashboardS7 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS7 === void 0 || (_store$homeDashboardS7 = _store$homeDashboardS7.selectedPropertyDetails().details.feeSetup.getPropertyFee({
    feeName
  })) === null || _store$homeDashboardS7 === void 0 ? void 0 : _store$homeDashboardS7.value : '';
  const handleTouched = () => {
    if (!isInputTouched) setInputTouched(true);
  };
  const handleFeeChange = (e, value) => {
    if (value === 'exclude-fee') {
      var _store$homeDashboardS8, _store$homeDashboardS9;
      (_store$homeDashboardS8 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS8 === void 0 || _store$homeDashboardS8.selectedPropertyDetails().details.feeSetup.updateFee({
        feeName,
        value: null
      });
      (_store$homeDashboardS9 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS9 === void 0 || _store$homeDashboardS9.selectedPropertyDetails().details.feeSetup.validateFees(true);
    } else {
      var _store$homeDashboardS0, _store$homeDashboardS1;
      (_store$homeDashboardS0 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS0 === void 0 || _store$homeDashboardS0.selectedPropertyDetails().details.feeSetup.updateLateFee({
        feeUnitType: FEE_UNIT_TYPES.fixedAmount,
        value: ''
      });
      (_store$homeDashboardS1 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS1 === void 0 || _store$homeDashboardS1.selectedPropertyDetails().details.feeSetup.validateFees(false);
    }
  };
  const handleSignChange = (e, value) => {
    if (value) {
      var _store$homeDashboardS10;
      (_store$homeDashboardS10 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS10 === void 0 || _store$homeDashboardS10.selectedPropertyDetails().details.feeSetup.updateFee({
        feeName,
        feeUnitType: value
      });
    }
  };
  const inputHandleChange = value => {
    var _store$homeDashboardS11, _store$homeDashboardS12;
    (_store$homeDashboardS11 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS11 === void 0 || _store$homeDashboardS11.selectedPropertyDetails().details.feeSetup.updateLateFee({
      feeUnitType,
      value
    });
    (_store$homeDashboardS12 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS12 === void 0 || _store$homeDashboardS12.selectedPropertyDetails().details.feeSetup.validateFees(+value > 0);
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.wrapper
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h4"
  }, t('add_new_property_flow.late_fee_warning')), /*#__PURE__*/React.createElement("div", {
    className: classes.xsSection
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body2"
  }, t('add_new_property_flow.late_fee_description'))), /*#__PURE__*/React.createElement("div", {
    className: classes.controlsWrapper
  }, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    value: isFeeExcluded() ? 'exclude-fee' : 'set-fee',
    onChange: handleFeeChange,
    exclusive: true
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: "exclude-fee"
  }, t('add_new_property_flow.exclude_this_fee')), /*#__PURE__*/React.createElement(ToggleButton, {
    value: "set-fee"
  }, t('add_new_property_flow.set_this_fee'))), !isFeeExcluded() && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ToggleButtonGroup, {
    exclusive: true,
    onChange: handleSignChange,
    className: "".concat(classes.signToggler),
    value: (_store$homeDashboardS13 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS13 === void 0 || (_store$homeDashboardS13 = _store$homeDashboardS13.selectedPropertyDetails().details.feeSetup.getPropertyFee({
      feeName
    })) === null || _store$homeDashboardS13 === void 0 ? void 0 : _store$homeDashboardS13.feeUnitType
  }, /*#__PURE__*/React.createElement(ToggleButton, {
    value: FEE_UNIT_TYPES.fixedAmount
  }, "$"), /*#__PURE__*/React.createElement(ToggleButton, {
    value: FEE_UNIT_TYPES.percentage
  }, "%")), /*#__PURE__*/React.createElement("div", {
    className: "".concat(classes.input, " ").concat(classes.currencyToggler)
  }, /*#__PURE__*/React.createElement(FormControl, {
    variant: "outlined",
    key: feeName,
    onKeyPress: event => {
      if (!/[0-9]|[.,]/.test(event.key)) {
        event.preventDefault();
      }
    },
    onChange: e => {
      if (!/^\d+([.,]\d{0,2})?$|^$/.test(e.target.value)) return;
      inputHandleChange(e.target.value);
    },
    error: isInputTouched && inputValue === ''
  }, /*#__PURE__*/React.createElement(InputLabel, {
    htmlFor: "lateFee"
  }, t('add_new_property_flow.fee_value')), /*#__PURE__*/React.createElement(OutlinedInput, {
    id: "lateFee",
    name: "lateFee",
    label: t('add_new_property_flow.fee_value'),
    type: "number",
    placeholder: "0.00",
    value: (_store$homeDashboardS14 = store.homeDashboardStore.getCurrentCompany) === null || _store$homeDashboardS14 === void 0 || (_store$homeDashboardS14 = _store$homeDashboardS14.selectedPropertyDetails().details.feeSetup.getPropertyFee({
      feeName
    })) === null || _store$homeDashboardS14 === void 0 ? void 0 : _store$homeDashboardS14.value,
    onBlur: handleTouched,
    startAdornment: feeCurrency === FEE_UNIT_TYPES.fixedAmount && /*#__PURE__*/React.createElement(InputAdornment, {
      position: "start"
    }, "$"),
    endAdornment: feeCurrency === FEE_UNIT_TYPES.percentage && /*#__PURE__*/React.createElement(InputAdornment, {
      position: "end"
    }, "%")
  }))))));
});